enum FieldType {
  GENERAL_STUDIES = 1,
  MATH_AND_PHYSICS = 2,
  HUMANITIES = 3,
  NATURAL_SCIENCES = 4,
  ARTS = 5,
  EDUCATION_SCIENCES = 6,
}

export default FieldType;
